/** Чем подписан гость, у которого имени нет. Одна строка на все экраны — см. `guestDisplayName`. */
export const GUEST_WITHOUT_NAME = 'Без имени'

/**
 * Имя гостя, пригодное к показу.
 *
 * ⚠️ ПУСТОЕ ИМЯ — ЭТО ЗНАЧЕНИЕ, А НЕ СБОЙ ЗАГРУЗКИ. Площадка присылает бронь по одному телефону, и
 * в реальной выгрузке таких 118 из 14 610 (§3 спеки clients-service). Значит показать его обязан
 * КАЖДЫЙ экран, где стоит имя гостя, а не только карточка профиля.
 *
 * ⚠️ ПРАВИЛО ОДНО, А МЕСТ ДВЕНАДЦАТЬ, и вот они все: список броней, пилюля шахматки, строка задачи,
 * подтверждение действия по задаче, три места переписки (список, шапка треда, контекст брони),
 * сводка, аналитика консьержа, диалог привязки чата, шапка карточки брони и ДОСТУПНОЕ ИМЯ самой
 * модалки брони. Пока у стенда не было безымянного гостя, каждое из них печатало на его месте
 * ПУСТОТУ — ячейку без текста, `<h1>` без строки, «Бронь bk_… — » с висящим тире. Ни один гейт
 * этого поймать не мог: тип поля `string`, значение корректно, пусто оно ровно у того гостя,
 * которого в фикстурах не было. Нашлось скриншотом, когда такой гость появился.
 *
 * Поэтому правило живёт ЗДЕСЬ, а не переписывается на каждом экране: переписанное двенадцать раз,
 * оно разъедется — и разъедется там, где о нём забыли. Ровно это случилось с концом курсорного
 * списка (`shared/api/pagination.ts`): шесть списков, и во всех шести одинаково неверно.
 *
 * ⚠️ Подписей у безымянного гостя в продукте ТРИ, и это не разнобой, а разные предложения:
 * «Без имени» — значение в строке или заголовке (здесь); «имя не указано» — пояснение рядом с
 * телефоном, которым карточка гостя его ТИТУЛУЕТ; «Гость без имени» — та же карточка, когда и
 * контакта нет. Поэтому карточка гостя это правило не зовёт: у неё есть контакты, и назвать
 * человека ей есть чем (`entities/client`, `clientTitle`). Здесь на входе одна строка имени —
 * и когда она пуста, назвать нечем.
 */
export function guestDisplayName(name: string | undefined | null): string {
  return name?.trim() || GUEST_WITHOUT_NAME
}
